import { RecurringBatch, RecurringBatchOptions } from 'data/models/RecurringBatch';
import { ReqChangeId, makePITKey, makePITDataKey } from './PITUtils';

export type RecurringBatchPITOptions = ReqChangeId<RecurringBatchOptions>;
export const RecurringBatchPITKey = makePITKey<RecurringBatch>(RecurringBatch.key);
export const RecurringBatchPITDataKey = makePITDataKey<RecurringBatchOptions>(RecurringBatch.dataKey);



// WEBPACK FOOTER //
// ./data/models/RecurringBatchPIT.ts